'use client';

import RegisterForm from '@/components/features/auth/RegisterForm';
import FloatingWhatsAppButton from '@/components/shared/FloatingWhatsAppButton';

export default function RegisterPage() {
  return (
    <>
      <RegisterForm />
      <FloatingWhatsAppButton />
    </>
  );
}
